
import { defineComponent } from 'vue'

export default defineComponent({
    props: {
        horizontal: {
            type: Boolean,
            default: false,
        },
        vertical: {
            type: Boolean,
            default: false,
        },
        thicknessInPx: {
            type: Number,
            default: 1
        }
    }
})
